module.exports = __webpack_public_path__ + "img/product-discount-two.0530d4f.png";